(() => {
  const scenes = document.querySelector('[data-cross-scenes]');
  scenes?.querySelectorAll('[data-scene-image]').forEach(button => button.addEventListener('click', () => {
    scenes.querySelector('.scene-image').src = button.dataset.sceneImage;
    scenes.querySelectorAll('[data-scene-image]').forEach(item => item.setAttribute('aria-pressed',String(item === button)));
  }));
  document.querySelectorAll('.detail-button').forEach(button => {
    const item = button.closest('.detail-item');
    button.setAttribute('aria-expanded','false');
    button.addEventListener('click', () => {item.classList.toggle('open');button.setAttribute('aria-expanded',String(item.classList.contains('open')));});
  });
  document.querySelectorAll('[data-detail-target]').forEach(button => button.addEventListener('click', () => {
    const item = document.querySelector(`[data-detail="${button.dataset.detailTarget}"]`);
    item?.querySelector('.detail-button').click();
  }));
  document.querySelectorAll('[data-film-direction]').forEach(button => button.addEventListener('click', () => document.querySelector('.film-strip')?.scrollBy({left:Number(button.dataset.filmDirection)*460,behavior:'smooth'})));
  const dialog = document.querySelector('[data-cross-lightbox]');
  document.querySelectorAll('.film-card').forEach(card => card.querySelectorAll('.film-zoom,.film-open').forEach(button => button.addEventListener('click', () => {
    dialog.querySelector('[data-cross-lightbox-image]').src = card.dataset.full;
    dialog.querySelector('[data-cross-lightbox-image]').alt = card.dataset.caption || card.dataset.colour;
    dialog.querySelector('[data-cross-lightbox-title]').textContent = card.dataset.caption || card.dataset.colour;
    dialog.showModal();
  })));
  document.querySelector('[data-cross-lightbox-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click',event => {if(event.target === dialog)dialog.close();});
  const updateColourModel = () => {
    const selected = document.querySelector('[data-signature-option][data-colour-name][aria-pressed="true"]');
    const model = document.querySelector('[data-cross-colour-model]');
    if (selected && model) { model.src=selected.dataset.colourImage;model.alt=selected.dataset.colourName; }
    document.querySelectorAll('[data-cross-colour]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.crossColour === selected?.dataset.optionValue)));
  };
  document.querySelectorAll('[data-signature-option]').forEach(button => button.addEventListener('click',updateColourModel));
  document.querySelectorAll('[data-cross-colour]').forEach(button=>button.addEventListener('click',()=>{
    [...document.querySelectorAll('[data-signature-option]')].find(item=>item.dataset.optionValue===button.dataset.crossColour)?.click();
    updateColourModel();
  }));
  updateColourModel();
  document.querySelectorAll('.film-quick-add').forEach(button => button.addEventListener('click', () => {
    const colour = button.closest('.film-card').dataset.colour;
    [...document.querySelectorAll('[data-signature-option]')].find(item=>item.dataset.optionValue===colour)?.click();
    document.querySelector('[data-signature-product] form')?.requestSubmit();
  }));
})();
